export const PackagedUseCaseRoutes = [
  {
    path: 'packagedUseCase',
    alias: 'packagedUseCase',
    query: ['configId', 'fromAutomation', 'actionOnSkip', 'fromDashboard'],
    lazy: () => import('./PackagedUseCase/PackagedUseCase'),
  },
] as const
